module.exports = {
      id: "icon-twitter-usage",
      viewBox: "0 0 19.798 20.251",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-twitter",
      toString: function () {
        return this.url;
      }
    }